import { useMemo } from 'react';
import { ApiService } from '@/services/api';
import { useGetBackendUrl } from './use-get-backend-url';
import { useDataMode } from '@/providers/DataModeProvider';

export function useApiService() {
  const backendUrl = useGetBackendUrl();
  const { isLiveMode, dataMode } = useDataMode();

  const api = useMemo(() => {
    return new ApiService(backendUrl, isLiveMode);
  }, [backendUrl, isLiveMode]);

  return { api, dataMode };
}
